import React, { useState } from "react";
import { Link, useHistory } from 'react-router-dom';
import Header from "./Header";
import { ROUTE_BASE_URL } from "../../api/common";
import axios from "axios";
import { baseUrl } from "../../api/common";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import Footer from "./Footer";
import { encryptSlug } from "../../util/encryption";
const UserMemberApplicationLogin = () => {

    const history = useHistory();

	const [email,setEmail]= useState("");
	const [applicationId,setApplicationId]= useState("");

	const trackApplication = async ()=> {
		if(!email){
		  showToast("Email cannot be empty", "error");
		  return;	
		}
        if(!applicationId){
          showToast("Application ID cannot be empty", "error");
          return;	
        }
		try {
			const response = await axios.post(
			  `${baseUrl}/api/track_application`,
			  { email: email,application_no:applicationId },
			  {
				headers: {
				  "Content-Type": "application/json",
				  Authorization: localStorage.getItem("access_token"),
				},
			  }
			);	  
			if (response.data.status) {
              history.replace(`${ROUTE_BASE_URL}/user-member-application-status/${encryptSlug(`${response.data.data[0].id}`)}`);
			} else {
              showToast(response.data.message, "error");
			}
		  } catch (error) {
			console.error("Error during submission:", error);
		}    
	}

    return (
        <>
            <ToastMessage />
            <section className="user_div_total">
                <Header/>
                <div className="container pt-50">
                    <div className="row heaight_div_app">
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                            <div className="card">
                                <div className="body">
                                    <div className="header appli_header">
                                        <h4>Track Application Status</h4>
                                    </div>
                                        <div className="form-group">
                                            <label>Registered Email ID</label>
                                            <input type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="form-control" />
                                        </div>
                                        <div className="form-group">
                                            <label>Application ID</label>
                                            <input type="text" value={applicationId} onChange={(e)=>setApplicationId(e.target.value)} className="form-control" />
                                        </div>
                                        <div>
                                        <button onClick={()=>trackApplication()}  className="btn btn-primary">Track Status</button>
                                          <div className="contact_support">
                                            <p>
                                            Haven't tracked your application yet?{" "}
                                            <Link to={`${ROUTE_BASE_URL}/user-member-application-not-found`}>Need help?</Link>
                                            </p>
                                          </div>                                           
                                        </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4"></div>
                    </div>
                </div>
                <Footer/>
            </section>
        </>
    );

}


export default UserMemberApplicationLogin
